"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("../../../../../ww_project/Resources/Private/app/components/AbstractComponent"));
var fetch_1 = require("../../../../../ww_project/Resources/Private/app/utility/fetch");
var constants_1 = require("../data/constants");
var Jobs = /** @class */ (function (_super) {
    __extends(Jobs, _super);
    function Jobs() {
        var _this = _super.call(this, constants_1.DATA_JOBS) || this;
        _this.url = '';
        _this.page = 1;
        _this.ajaxOffset = 0;
        _this.allLoaded = false;
        _this.isAjaxListRunning = false;
        _this.sections = '';
        _this.branches = '';
        if (!_this.getElement())
            return _this;
        _this.preSelectedSection = _this.getElement().getAttribute(constants_1.DATA_JOBS_SECTIONS);
        if (_this.preSelectedSection != null) {
            _this.sections = _this.preSelectedSection;
        }
        _this.filterError = _this.getChildElement("[".concat(constants_1.DATA_FILTER_ERROR, "]"));
        _this.filterButton = _this.getChildElement("[".concat(constants_1.DATA_FILTER_SUBMIT, "]"));
        _this.filterClear = _this.getElement().querySelectorAll("[".concat(constants_1.DATA_FILTER_CLEAR, "]"));
        var loadButton = _this.getChildElement("[".concat(constants_1.DATA_JOBS_CONTAINER, "]"));
        _this.url = loadButton.getAttribute(constants_1.DATA_JOBS_CONTAINER);
        _this.detailPage = document.querySelector("[".concat(constants_1.DATA_DETAIL_PAGE, "]")).getAttribute(constants_1.DATA_DETAIL_PAGE);
        _this.initEventListeners();
        return _this;
    }
    Jobs.prototype.initEventListeners = function () {
        var _this = this;
        this.filterButton.addEventListener('click', function () {
            _this.getFilter(_this.filterButton);
            _this.ajaxListJobs(_this.branches, _this.sections, true);
        });
        this.filterClear.forEach(function (element) {
            element.addEventListener('click', function () {
                _this.resetFilter();
            });
        });
        window.addEventListener('scroll', function () {
            var rect = _this.getChildElement("[".concat(constants_1.DATA_JOBS_CONTAINER, "]")).getBoundingClientRect();
            var currentScroll = window.scrollY + window.innerHeight;
            if (currentScroll + _this.ajaxOffset > rect.height && !_this.isAjaxListRunning) {
                _this.ajaxListJobs(_this.branches, _this.sections);
            }
        });
    };
    /**
     * Ajax call to get the next jobs
     */
    Jobs.prototype.ajaxListJobs = function (branches, sections, buttonClick) {
        return __awaiter(this, void 0, void 0, function () {
            var branchLink, sectionLink, response, jobsContainer, jobs, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.allLoaded)
                            return [2 /*return*/];
                        this.isAjaxListRunning = true;
                        this.url = '';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        branchLink = '&tx_wwjobs_jobs[branches]=' + branches;
                        sectionLink = '&tx_wwjobs_jobs[sections]=' + sections;
                        // Make variable an empty string if no branch is selected
                        if (branches == '' || branches == undefined) {
                            branchLink = '&tx_wwjobs_jobs[branches]=';
                        }
                        // Make variable an empty string if no section is selected
                        if (sections == '' || sections == undefined) {
                            sectionLink = '&tx_wwjobs_jobs[sections]=';
                        }
                        this.url = '?type=1678863165' +
                            '&tx_wwjobs_jobs[action]=ajaxList' +
                            '&tx_wwjobs_jobs[controller]=Jobs' +
                            branchLink +
                            sectionLink +
                            '&tx_wwjobs_jobs[detailPage]=' + this.detailPage +
                            '&tx_wwjobs_jobs[page]=' + this.page;
                        return [4 /*yield*/, fetch_1.Fetch.fetchPostData(this.url, null)];
                    case 2:
                        response = _a.sent();
                        jobsContainer = this.getChildElement("[".concat(constants_1.DATA_JOBS_CONTAINER, "]"));
                        this.page = response.page;
                        if (!this.allLoaded) {
                            this.isAjaxListRunning = false;
                            if (!response.hasNext) {
                                this.allLoaded = true;
                            }
                            try {
                                jobs = response.jobs;
                                if (buttonClick) {
                                    jobsContainer.innerHTML = JSON.parse(jobs);
                                }
                                else if (jobsContainer.childElementCount < response.count) {
                                    jobsContainer.insertAdjacentHTML('beforeend', JSON.parse(jobs));
                                }
                            }
                            catch (e) {
                                console.log(e);
                            }
                            if (response.hasNext) {
                                this.url = response.nextUrl;
                            }
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Jobs.prototype.getFilter = function (button) {
        this.page = 0;
        this.allLoaded = false;
        var allBranches = button.parentElement.previousElementSibling.previousElementSibling.querySelectorAll('.form-check');
        var allSections = button.parentElement.previousElementSibling.querySelectorAll('.form-check');
        var checkedBranches = [];
        var checkedSections = [];
        allBranches.forEach(function (branch) {
            if (branch.checked) {
                checkedBranches.push(branch.value);
            }
        });
        allSections.forEach(function (section) {
            if (section.checked) {
                checkedSections.push(section.value);
            }
        });
        this.branches = checkedBranches.join(', ');
        this.preSelectedSection ? this.sections = this.preSelectedSection : this.sections = checkedSections.join(', ');
    };
    /**
     * Reset filter attributes for jobs filter
     */
    Jobs.prototype.resetFilter = function () {
        this.page = 0;
        this.allLoaded = false;
        this.branches = '';
        this.preSelectedSection ? this.sections = this.preSelectedSection : this.sections = '';
        this.ajaxListJobs(this.branches, this.sections, true);
    };
    return Jobs;
}(AbstractComponent_1.default));
exports.default = Jobs;
